import { XoneraSpinner } from './XoneraSpinner';

/**
 * Full-screen, transparent loading spinner. Kept transparent so the app's
 * GridBackground shows through.
 *
 * The default fallback for BOTH route guards, which is what it was always for:
 * it used to be passed only on `/onboarding`, so every other route still
 * flashed the guards' own blue "Loading…" card - written out twice,
 * byte-identical in `ProtectedRoute` and `PublicRoute` - before the real screen
 * arrived.
 *
 * The mark itself, not lucide's `Loader2`. `XoneraSpinner` is the app's loading
 * indicator everywhere else; this was the last place still spinning a generic
 * ring, which meant the first thing a user saw on a cold load was the one
 * spinner that was not ours.
 *
 * Its "one instance per screen" cost note (eight animating `stroke-dasharray`
 * values force path re-tessellation per frame) is satisfied by construction
 * here — this fills the viewport, so there is exactly one.
 *
 * `XoneraSpinner` owns the `role='status'` and the `sr-only` label. Without
 * them this announces nothing at all, and it covers the auth check on every
 * guarded route in the app — the one moment a screen-reader user has no other
 * cue that anything is happening.
 */
export function FullScreenSpinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className='flex h-screen w-full items-center justify-center'>
      <XoneraSpinner
        className='h-8 w-8 text-brand-500 dark:text-primary'
        label={label}
      />
    </div>
  );
}
